import { Box, Grid, Typography } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import HeroWallpaper from '../assets/HeroWallpaper.webp'; // Adjust the path as necessary

const Hero = () => {
  const leftRef = useRef();
  const rightRef = useRef();
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (leftRef.current) {
        const top = leftRef.current.getBoundingClientRect().top;
        if (top < window.innerHeight - 100) setShowLeft(true);
      }

      if (rightRef.current) {
        const top = rightRef.current.getBoundingClientRect().top;
        if (top < window.innerHeight - 100) setShowRight(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Box
      sx={{
        width: '100%',
        backgroundImage:`url(${HeroWallpaper})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'start',
        pb: '50px',
      }}
    >
      <Box
        sx={{
          width: '85%',
          mt: '140px',
        }}
        maxWidth="lg"
      >
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          maxWidth="lg"
        >
          {/* Left Section */}
          <Grid item xs={12} md={6}>
            <Box
              ref={leftRef}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: { xs: 'flex-start', sm: 'flex-start', md: 'flex-start' },
                gap: 2.5,
                opacity: showLeft ? 1 : 0,
                transform: showLeft ? 'translateY(0px)' : 'translateY(80px)',
                transition: 'all 1s ease',
              }}
            >

              <Typography
                component="h4"
                sx={{
                  animationName: 'fadeInUp',
                  animationDuration: '0.8s',
                  animationDelay: '0.8s',
                  animationFillMode: 'both',
                  animationIterationCount: 1,
                  animationTimingFunction: 'ease',
                  animationDirection: 'normal',
                  animationPlayState: 'running',

                  border: '2px solid rgb(12, 90, 219)',
                  borderRadius: '7px',
                  color: 'rgb(12, 90, 219)',
                  fontFamily: 'Rajdhani',
                  fontWeight: 600,
                  fontSize: '18px',
                  textTransform: 'uppercase',
                  lineHeight: '38px',
                  height: '42px',
                  paddingLeft: '15px',
                  paddingRight: '15px',
                  backgroundColor: 'transparent',

                  display: 'inline-block',
                  position: 'relative',
                  boxSizing: 'border-box',
                  marginBottom: '16px',
                  transition: 'all 0.5s ease',
                  pointerEvents: 'none',
                  userSelect: 'none',
                  textAlign: 'left',
                  zIndex: 1,

                  WebkitFontSmoothing: 'antialiased',
                  WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
                }}
              >
                WELCOME TO LOOPSYS
              </Typography>


              <Typography
                sx={{ fontFamily: 'Rajdhani', color: '#232323' }}
                variant="h1"
                component="h1"
                fontWeight="bold"
                lineHeight={1.2}
              >
                Empowering Your Brand<br />
                In The <span style={{ color: '#075AD6' }}>Digital </span>Universe
              </Typography>

              <Typography
                fontSize={20}
                color="#686868"
                fontWeight={600}
                sx={{ fontFamily: 'Nunito, sans-serif' }}
                lineHeight={1.3}
              >
                Take charge of your business continuity <br />
                with innovative IT solutions
              </Typography>
            </Box>
          </Grid>

          {/* Right Section (hidden on mobile) */}
          <Grid
            item
            xs={12}
            md={6}
            sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}
          >
            <Box
              ref={rightRef}
              component="img"
              src="https://ittech.ditsolution.net/wp-content/uploads/2024/09/B-1.png"
              alt="Visual"
              sx={{
                width: '100%',
                maxWidth: '530px',
                borderRadius: 2,
                opacity: showRight ? 1 : 0,
                transform: showRight ? 'translateY(0px)' : 'translateY(80px)',
                transition: 'all 1s ease',
              }}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Hero;
